import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { IValidationService, ValidatorConfig } from '@fmnts/declarative-forms';
import { dateRangeValidator } from './validators/date-range.validator';

const enum DateValidatorNames {
  DateRange = 'dateRange',
}

@Injectable({
  providedIn: 'root',
})
export class DateValidationBuilder implements IValidationService {
  buildValidator(validator: ValidatorConfig): ValidatorFn[] {
    switch (validator.name) {
      case DateValidatorNames.DateRange:
        return [dateRangeValidator(validator.args.min, validator.args.max)];
    }

    return [];
  }
}
